const isSafari = (navigator.vendor.match(/apple/i) || '').length > 0;
export default isSafari